import { classNames } from "primereact/utils";

import { WSFieldStatus } from "../../types/forms";

import styles from "./getStatusStyles.module.scss";

export const getStatusStyles = (status?: WSFieldStatus) => {
  const styleStatus = status || "default";

  return classNames({
    [styles[`status-${styleStatus}`]]: !!styleStatus
  });
};
